import { render, staticRenderFns } from "./AppointmentCalendarDashboard.vue?vue&type=template&id=5b14a39f"
import script from "./AppointmentCalendarDashboard.vue?vue&type=script&lang=js"
export * from "./AppointmentCalendarDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports